
import { jwtDecode } from "jwt-decode";
import User from "models/user";
import { getLocalStorage, setLocalStorage } from "utils/commonHelper";
import { BaseAuth } from "./base-auth";

export class OAuthService extends BaseAuth {
    /**
     * Constructor
     */
    constructor() {
        super();
    }

    /**
     * Login using mid
     * @returns {object} User
     */
    async login(token) {
        try {
            // This will start the login process by redirecting (window.location.assign())
            // the user to McKinsey ID login broker
            const loginResult = jwtDecode(token);
            // const { tenants, roles } = this.getTenantAndRolesFromGroups(loginResult.groups);
            const user = new User({
                "email": loginResult?.unique_name,
                "firstName": loginResult?.given_name,
                "lastName": loginResult?.family_name,
                roles: ["admin", "viewer", "super_admin"],
                tenants: ["test", "demo", "main"]
            });
            setLocalStorage("user", user, true);
            this.setHeader({
                "authorization": `Bearer ${token}`
            });

            // When mid.login() resolves, you can safely display the app
            return user;
        } catch (err) {
            // Something when wrong in the login process, display an error message
            return null;
        }
    }

    /**
     * Logout using mid
     */
    async logout() {
        // TODO: Implement logout logic if needed
        super.logout();
    }

    /**
     * Check if user is authenticated
     * @param {Function} callBack - Callback method to be called after auth
     */
    isAuthed(callBack) {
        // This will check if the user is already login (if you have valid tokens stored locally)
        if (!this.checkTokenValid()) {
            callBack(false);
        } else {
            callBack(true);
        }
    }

    /**
     * Get user from mid service if not in local storage.
     * @param {boolean} forceUpdate - True, if user info should be fetched again from MID
     * @returns {User} = User
     */
    async getUser(forceUpdate = true) {
        let user;
        const userObject = getLocalStorage("user", true);
        if (userObject && !forceUpdate) {
            user = new User(userObject);
        } else {
            user = await this.login();
        }

        return user;
    }

    /**
     * Treat groups that starts with tenant- as tenant and others as user role
     * @param {Array} groups - Groups from MID login
     * @returns {object} - Roles and tenants
     */
    getTenantAndRolesFromGroups(groups) {
        const tenants = [];
        const roles = [];
        // Treat groups that starts with tenant- as tenant and others as user role
        groups.forEach((group) => {
            group.startsWith("tenant-") ? tenants.push(group.replace("tenant-", "")) : roles.push(group);
        });

        return { roles, tenants };
    }
}

